"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RootNode = void 0;
const react_1 = __importStar(require("react"));
const graphql_zeus_1 = require("graphql-zeus");
const typestyle_1 = require("typestyle");
const PaintNode_1 = require("../PaintNode");
const NewNode_1 = require("../NewNode");
const theme_1 = require("../../../editor/theme");
const trees_1 = require("../../../state/containers/trees");
const index_1 = require("../components/index");
const NodeCaption = typestyle_1.style({
    flexBasis: '100%',
    margin: `15px 15px`,
    display: 'flex',
    borderBottom: `1px solid`,
    paddingBottom: 5,
    alignItems: 'center',
    userSelect: 'none',
    '-moz-user-select': '-moz-none',
    $nest: Object.assign({}, Object.keys(theme_1.GraphQLColors).reduce((a, b) => {
        a[`&.CaptionType-${b}`] = {
            color: `${theme_1.GraphQLColors[b]}`,
            borderColor: `${theme_1.GraphQLColors[b]}22`,
        };
        return a;
    }, {})),
});
const CaptionTitle = typestyle_1.style({
    marginRight: 10,
});
const NodeContainer = typestyle_1.style({
    padding: 10,
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    height: '100%',
});
exports.RootNode = ({ node, libraryNode }) => {
    var _a, _b;
    const thisNode = react_1.useRef(null);
    const { tree, setTree, readonly } = trees_1.useTreesState();
    const [filterNodes, setFilterNodes] = react_1.useState('');
    return (react_1.default.createElement("div", { className: `${NodeContainer}`, ref: thisNode },
        react_1.default.createElement("div", { className: `${NodeCaption} CaptionType-${node.name}` },
            react_1.default.createElement("span", { className: CaptionTitle }, node.name),
            react_1.default.createElement(index_1.MenuSearch, { autoFocus: false, onClear: () => {
                    setFilterNodes('');
                }, value: filterNodes, onChange: setFilterNodes })),
        !readonly && (react_1.default.createElement(NewNode_1.NewNode, { node: node, onCreate: (name) => {
                if (node.data.type === graphql_zeus_1.TypeSystemDefinition.DirectiveDefinition) {
                    tree.nodes.push(Object.assign(Object.assign({}, node), { name, args: [], type: {
                            name: graphql_zeus_1.TypeDefinitionDisplayMap[node.data.type],
                            directiveOptions: [graphql_zeus_1.Directive.OBJECT],
                        } }));
                }
                else {
                    tree.nodes.push(Object.assign(Object.assign({}, node), { name, args: [], type: {
                            name: graphql_zeus_1.TypeDefinitionDisplayMap[node.data.type],
                        } }));
                }
                setTree(Object.assign({}, tree));
            } })), (_a = node.args) === null || _a === void 0 ? void 0 :
        _a.map((a, i) => {
            return (react_1.default.createElement(PaintNode_1.PaintNode, { key: a.name, node: a, isMatchedToSearch: a.name.toLowerCase().includes(filterNodes.toLowerCase()) }));
        }), (_b = libraryNode === null || libraryNode === void 0 ? void 0 : libraryNode.args) === null || _b === void 0 ? void 0 :
        _b.map((a, i) => {
            return (react_1.default.createElement(PaintNode_1.PaintNode, { isLibrary: true, key: a.name, node: a, isMatchedToSearch: a.name.toLowerCase().includes(filterNodes.toLowerCase()) }));
        })));
};
